import { constants as config, restrictions as restrictionConfig } from '@config';

import DesignFacade from '../../../facade/design/design';
import EditorFacade from '../../../facade/editor/editor';
import RestrictionsFacade from '../../../facade/restrictions/restrictions';
import { instance as CompanyFactory } from '../../../factory/company';
import { sortByProperty } from '../../../utils/sort';
import ScrollableMixin from '../components/mixins/scrollable';

import template from './template.hbs';

module.exports = Backbone.mixin(Backbone.View.extend({
  events: {
    'click li.show-restriction': 'showRestrictionEvent',
    'mouseover li.show-restriction': 'mouseoverRestrictionEvent',
    'mouseleave li.show-restriction': 'mouseleaveRestrictionEvent'
  },

  initialize: function () {
    const _refresh = () => {
      const isAlreadyThere = this.$el.find('.restricted').length;
      if (isAlreadyThere) this.render();
    };

    DesignFacade.on('template.update.restricted', _refresh);
    EditorFacade.on('page.move_to', _refresh);
  },

  showRestrictionEvent: function (event) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const id = event.currentTarget.closest('li').dataset.element;
    const $elem = this._findElement(id);

    canvas.setMode('select');
    canvas.selectOnly([$elem[0]], true);
  },

  mouseoverRestrictionEvent: function (event) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const id = event.currentTarget.closest('li').dataset.element;
    const selectedElements = INKIVE.EditorFacade.selectedElements;
    const $elem = this._findElement(id);

    const selector = canvas.selectorManager.requestSelector($elem[0]);
    (selectedElements && selectedElements[0] && selectedElements[0].id === id) || (selector && selector.showGrips(false));
  },

  mouseleaveRestrictionEvent: function (event) {
    const canvas = INKIVE.Tool.getInstance().editor.canvas;
    const id = event.currentTarget.closest('li').dataset.element;
    const selectedElements = INKIVE.EditorFacade.selectedElements;
    const $elem = this._findElement(id);

    (selectedElements && selectedElements[0] && selectedElements[0].id === id) || canvas.selectorManager.releaseSelector($elem[0]);
  },

  // TODO remove jquery
  _findElement: function (id) {
    let $elem;
    if (id === 'background') {
      const image = $(`#${config.background.image}`);
      const rect = $(`#${config.background.color}`);

      $elem = image.length ? image : rect;
      if (!$elem.length) $elem = $('#svgcontent').children('g.background');
    } else {
      $elem = $('#' + id);
    }

    return $elem;
  },

  show: function () {
    const isAlreadyThere = this.$el.find('.restricted').length;
    isAlreadyThere || this.render();
  },

  render: async function () {
    CompanyFactory.getCompanyData().then((companyData) => {
      if (RestrictionsFacade.hasAddOnAndFeature(config.featureFlag.addOn, config.featureFlag.keys.restrictionsOverview)) return;

      this.hasWorkflow = companyData.add_ons.includes(config.featureFlag.workflow);
      this.simplified = !companyData.features[config.featureFlag.templateRestrictions] ||
        !companyData.features[config.featureFlag.templateRestrictions].includes(config.featureFlag.keys.templateGranularPermission);

      const data = {
        doList: this.getDoList(),
        addList: this.getAddList(),
        changeList: this.getChangeList()
      };

      _.extend(data, {
        hasDoList: data.doList.length > 0,
        hasAddList: data.addList.length > 0,
        hasChangeList: data.changeList.length > 0
      });

      _.extend(data, {
        locked: !data.hasDoList && !data.hasAddList && !data.hasChangeList,
        cantChange: !data.hasAddList && !data.hasChangeList
      });

      this.$el.html(template(data));
      INKIVE.Helpers.initTooltips(this.$el);
    });
  },

  getDoList: function () {
    const list = this.hasWorkflow
      ? restrictionConfig.actionsList.concat(restrictionConfig.requestActionsList)
      : restrictionConfig.actionsList;

    const doList = new Set(list.filter((functionality) => {
      const isAllowed = RestrictionsFacade.isFunctionalityAllowed(functionality);
      const isAnimationFile = functionality === 'function_animation_file';
      return isAnimationFile
        ? isAllowed && INKIVE.C.SHOW_ANIMATION
        : isAllowed;
    }).map((functionality) => 'tool.restricted.do.' + functionality.replace('_request', '')));

    return [...doList];
  },

  getAddList: function () {
    return _.chain(['image_add', 'text_add', 'table_add', 'vector_add', 'logo_add', 'icon_add', 'qrcode_add', 'video_add', 'qrcode_add'])
      .filter(RestrictionsFacade.isFunctionalityAllowed)
      .map(function (f) { return 'tool.restricted.add.' + f; })
      .value();
  },

  getChangeList: function () {
    const simplified = this.simplified;

    return _.compact(_.map(DesignFacade.get(), function (element) {
      let name;
      if (element.name) {
        name = element.name;
      } else {
        const idParts = element.id.split('_');
        name = element.type;

        if (idParts.length > 1) {
          name += ' ' + idParts[1];
        }

        name = name.charAt(0).toUpperCase() + name.slice(1);
      }

      const result = {
        name,
        icon: restrictionConfig.icons[element.type],
        element: element.id,
        change_image: canReplace(element),
        change_text: canChangeText(element),
        change_style: canChangeStyle(element)
      };

      return result.change_image || result.change_text || result.change_style
        ? result
        : null;
    })).sort(sortByProperty('name'));

    function canReplace (element) {
      if (simplified) return !INKIVE.RestrictionsFacade.getElementRestrictions(element.id).length;

      const type = element.type === 'sticker' ? 'vector' : element.type;
      const couldBeReplaced = ['image', 'background', 'logo', 'icon', 'video', 'vector'].includes(type);

      if (!couldBeReplaced) {
        return false;
      }

      if (element.type === 'background') {
        return _.any(RestrictionsFacade.getAllElementPermissions('background'), function (p) {
          return p.basic && p.basic.image;
        });
      }

      return RestrictionsFacade.isActionAllowed(`${type}_replace`, element.id);
    }

    function canChangeText (element) {
      if (simplified) return !INKIVE.RestrictionsFacade.getElementRestrictions(element.id).length;
      let permission = null;
      if (element.type === 'text') permission = 'text_change_content';
      if (element.type === 'table') permission = 'table_content';

      return permission
        ? RestrictionsFacade.isActionAllowed(permission, element.id)
        : false;
    }

    function canChangeStyle (element) {
      if (simplified) return !INKIVE.RestrictionsFacade.getElementRestrictions(element.id).length;
      if (element.type === 'background') {
        return RestrictionsFacade.getAllElementPermissions('background').some(
          permission =>
            (permission.basic && Object.keys(permission.basic).some(key => key !== 'image' && permission.basic[key])) ||
          Object.keys(permission).some(key => key !== 'basic' && permission[key])
        );
      }

      const notStylePermissions = [
        'image_add',
        'image_replace',
        'text_add', 'text_change_content',
        'table_add',
        'vector_add', 'icon_add',
        'logo_add', 'logo_replace',
        'video_add', 'video_replace',
        'qrcode_add',
        'vector_replace'
      ];

      return _.any(RestrictionsFacade.getAllDefaultPermissions(), function (value, key) {
        const type = RestrictionsFacade.getType(element.type);
        return notStylePermissions.indexOf(key) === -1 &&
          key.indexOf(type) === 0 &&
          RestrictionsFacade.isActionAllowed(key, element.id);
      });
    }
  }
}), ScrollableMixin);
